module.exports = __webpack_public_path__ + "img/DE00588.4f0f3ef0.png";